import React, { useEffect, useState } from 'react';
import {
  AppBar,
  Avatar,
  Box,
  Button,
  Container,
  CssBaseline,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Toolbar,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  TableContainer
} from '@mui/material';
import Selector from '../../../components/Selector';
import { alpha } from '@mui/material/styles';
import AppNavbar from '../../../components/AppNavbar';
import Header from '../../../components/Header';
import SideMenu from '../../../components/SideMenu';
import { ArrowBack, ArrowBackIos } from '@mui/icons-material';
import AppTheme from '../../../shared-theme/AppTheme';
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from '../../dashboard/theme/customizations';
import { StyledCellHeader } from '../../../components/StyledCellHeader';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchSucursales, fetchUsuarios } from '../../../utils/generalsFetch';


const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
}


const AlmacenDetails = (props) => {

  const navigate = useNavigate()
  const {id} = useParams()

  const [nombre, setNombre] = useState("")
  const [direccion, setDireccion] = useState("")
  const [errors, setErrors] = useState({});

  const products = [
    { name: 'Laptop Modelo X', category: 'Electrónica', stock: 150 },
    { name: 'Smartphone Modelo Y', category: 'Electrónica', stock: 200 },
    { name: 'Tablet Modelo Z', category: 'Electrónica', stock: 100 },
    { name: 'Auriculares Inalámbricos', category: 'Accesorios', stock: 300 },
    { name: 'Cargador Portátil', category: 'Accesorios', stock: 250 },
  ];

  const [branches, setBranches] = useState([]);
  const [branchesSelected, setBranchesSelected] = useState([]); 
  const [users, setUsers] = useState([]);
  const [usersSelected, setUsersSelected] = useState([])

  useEffect(() => {
    fetchSucursales({ idcompany: localStorage.getItem('idcompany'), usuarioId: localStorage.getItem('id') })
    .then((data) => {
      setBranches(data);
      fetchUsuarios({ idcompany: localStorage.getItem('idcompany'), usuarioId: localStorage.getItem('id') })
      .then((data) => {
        setUsers(data);
      })
      .catch(err => console.log(err.message));
      fetchAlmacenById()

    })
    .catch(err => console.log(err.message));

    

    }, []);


   async function fetchAlmacenById() {
    const url = `${process.env.REACT_APP_SERVER_URL}/api/almacenes/${id}`;
  
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        }
      });
  
      const text = await response.text();
      try {
        const data = JSON.parse(text);
        if (!response.ok) {
          throw new Error(data.error || 'Error al obtener almacén');
        }
        var dataSucursales = Array.isArray(data) && data.length === 1 ? data[0].sucursales : data.sucursales
        setBranchesSelected(JSON.parse(dataSucursales)) 

        var dataUsers = Array.isArray(data) && data.length === 1 ? data[0].responsables : data.responsables
        setUsersSelected(JSON.parse(dataUsers)) 

        setNombre(data[0].nombre)
        setDireccion(data[0].direccion)


      } catch {
        throw new Error('Respuesta no es JSON: ' + text);
      }
    } catch (error) {
      throw error;
    }
   }


   async function updateAlmacen() {
    if (!validateFields()) {
      return;
    }
    const url = `${process.env.REACT_APP_SERVER_URL}/api/almacenes/${id}`;
    try {
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        },
        body: JSON.stringify({
          nombre,
          direccion,
          sucursales: branchesSelected,
          responsables: usersSelected
        })
      });

      if (!response.ok) {
        const error = await response.json();
        console.log(error)
        setErrors(prev => ({...prev, general: error.error || 'Error al actualizar almacén'}));
        throw new Error(error.error || 'Error al actualizar almacén');
      }

      navigate(-1)

      
    } catch (error) {
      setErrors(prev => ({...prev, general: error.message || 'Error desconocido'}));
      throw error;
    }
   }

  // Validation function
  const validateFields = () => {
    let newErrors = {};
    if (!nombre || nombre.trim() === "") {
      newErrors.nombre = "El nombre del almacén es obligatorio.";
    }
    if (!direccion || direccion.trim() === "") {
      newErrors.direccion = "La dirección del almacén es obligatoria.";
    }
    if (!branchesSelected || branchesSelected.length === 0) {
      newErrors.branchesSelected = "Debe seleccionar al menos una sucursal.";
    }
    if (!usersSelected || usersSelected.length === 0) {
      newErrors.usersSelected = "Debe seleccionar al menos un usuario responsable.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  

  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: 'flex' }}>
        <SideMenu />
        <AppNavbar />
        {/* Main content */}
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: 'auto',
          })}
        >
          <Stack
            spacing={2}
            sx={{
              alignItems: 'center',
              mx: 3,
              pb: 5,
              mt: { xs: 8, md: 0 },
            }}
          >
            <Header parent={"Logistica y Almacenes"} child={"Almacenes"}/>
            <Container maxWidth={false} sx={{ px: 5, py: 5 }}>

        <Box maxWidth={960} mx="auto" >
          <Box display="flex" justifyContent="flex-start" px={2} mb={1}>
            <Button startIcon={<ArrowBack/>} variant="outlined" onClick={()=>{navigate(-1)}}>Atrás</Button>
          </Box>
          <Typography variant="h4" fontWeight={700} px={2} py={2} textAlign={"start"}>{nombre}</Typography>

          <Box px={2} maxWidth={600} display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
            <TextField
              value={nombre}
              onChange={(e) => {
                setNombre(e.target.value);
              }}
              placeholder="Nombre del Almacén"
              fullWidth
              sx={{ mb: 3 }}
              error={!!errors.nombre}
              helperText={errors.nombre}
            />
            <TextField
              value={direccion}
              onChange={(e) => {
                setDireccion(e.target.value);
              }}
              placeholder="Dirección del Almacén"
              fullWidth
              sx={{ mb: 3 }}
              error={!!errors.direccion}
              helperText={errors.direccion}
            />
            <FormControl fullWidth sx={{ mb: 3 }}>
              <Selector
                  multiple
                  value={branchesSelected}
                  onChange={(e) => {
                    setBranchesSelected(e.target.value);
                  }}
                  options={branches}
                  placeholder="Seleccione una o varias sucursales"
                />
              {errors.branchesSelected && (
                <Typography color="error" variant="body2" fontSize={12} sx={{marginLeft:2}}>{errors.branchesSelected}</Typography>
              )}
            </FormControl>
            <FormControl fullWidth sx={{ mb: 4 }}>
              <Selector
                  multiple
                  value={usersSelected}
                  onChange={(e) => {
                    setUsersSelected(e.target.value);
                  }}
                  options={users}
                  placeholder="Usuarios responsables"
                />
              {errors.usersSelected && (
                <Typography color="error" variant="body2" fontSize={12} sx={{marginLeft:2}}>{errors.usersSelected}</Typography>
              )}
            </FormControl>
         {errors.general && (
           <Typography color="error" variant="body2" sx={{ mt: 2 }}>{errors.general}</Typography>
         )}
          </Box>

          <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
            
            <Table>
              <TableHead>
                <TableRow>
                  <StyledCellHeader>Producto</StyledCellHeader>
                  <StyledCellHeader>Categoría</StyledCellHeader>
                  <StyledCellHeader>Cantidad Disponible</StyledCellHeader>
                  <StyledCellHeader></StyledCellHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {products.map((p) => (
                  <TableRow key={p.name}>
                    <TableCell>{p.name}</TableCell>
                    <TableCell>{p.category}</TableCell>
                    <TableCell>{p.stock}</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', color: '#6a7681' }}>Transferir</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box display={"flex"} justifyContent={"flex-end"} px={2} py={2}>
            <Button variant="contained" color="primarybutton" sx={{fontWeight: "bold", marginTop:5}} onClick={updateAlmacen}>Actualizar Almacén</Button>
          </Box>

          <Box mt={5} textAlign="center">
            <Typography color="#6a7681" fontSize="0.875rem">@2024 Bankivo. Todos los derechos reservados.</Typography>
          </Box>
        </Box>
      </Container>
    </Stack>
    </Box>
    </Box>
    </AppTheme>
  );
};

export default AlmacenDetails;
